export enum TypeCancelCivilUnion {
  DeathCohabitant = '98',
}
